/** A storage whose every call is safe: Safari private mode, blocked cookies and full quotas all just miss. */
export class SafeStorage {
    backing;
    memory = new Map();
    constructor(backing) {
        this.backing = backing;
    }
    get(key) {
        try {
            const value = this.backing?.getItem(key);
            if (value != null)
                return value;
        }
        catch {
            // blocked: fall back to this page's memory
        }
        return this.memory.get(key) ?? null;
    }
    set(key, value) {
        this.memory.set(key, value);
        try {
            this.backing?.setItem(key, value);
        }
        catch {
            // blocked or full: memory only
        }
    }
    remove(key) {
        this.memory.delete(key);
        try {
            this.backing?.removeItem(key);
        }
        catch {
            // nothing to do
        }
    }
    getJson(key) {
        const raw = this.get(key);
        if (!raw)
            return null;
        try {
            return JSON.parse(raw);
        }
        catch {
            this.remove(key);
            return null;
        }
    }
    setJson(key, value) {
        this.set(key, JSON.stringify(value));
    }
}
/** window.localStorage when it can be read at all, else null. */
export function defaultStorage() {
    try {
        if (typeof window === 'undefined' || !window.localStorage)
            return null;
        const probe = '__oi_exp_probe';
        window.localStorage.setItem(probe, '1');
        window.localStorage.removeItem(probe);
        return window.localStorage;
    }
    catch {
        return null;
    }
}
